import { createGrowingDecliningDirectionToTagMap } from "app/pages/sales-intelligence/sub-modules/signals/constants/signalDirectionToTagMap";

import EcommerceSignalMetricChangeDirection from "./EcommerceSignalMetricChangeDirection";

export const ecommerceSignalMetricChangeDirectionToTagMap = createGrowingDecliningDirectionToTagMap({
    grew: EcommerceSignalMetricChangeDirection.Grew,
    declined: EcommerceSignalMetricChangeDirection.Declined,
});
